import { Method } from "axios";
import { ActionKeyPair, IService } from "@/shared/hooks/useCustomQuery";
import api from "@/shared/api/api";
import { PresetStatsParams, PackPresetStats, CreatorPresetStats, PresetStatsMeta, PresetStatsResponse } from "../model/presetStats.types";




export default class PresetStatsService implements IService {
    [key: string]: ActionKeyPair<any, any>;

    getPresetStats: ActionKeyPair<PresetStatsParams,
        { data: PackPresetStats[] | CreatorPresetStats[]; meta: PresetStatsMeta }> = {
            key: "preset-stats",
            actionBuilder: (params) => async () => {
                const {
                    startDate,
                    endDate,
                    page = 1,
                    limit = 10,
                    search = "",
                    sortBy,
                    sortOrder,
                    groupBy,
                } = params;

                try {
                    const response = await api<PresetStatsResponse<typeof groupBy>>({
                        url: `/v1/presets/statistics`,
                        method: "GET" as Method,
                        params: {
                            startDate,
                            endDate,
                            groupBy,
                            page,
                            limit,
                            search,
                            sortBy,
                            sortOrder,
                        },
                    });

                    if (!response) throw new Error("API response is null or undefined");

                    const { items } = response;

                    const meta: PresetStatsMeta = {
                        startDate: response.startDate ?? "",
                        endDate: response.endDate ?? "",
                        page: response.page ?? 1,
                        limit: response.limit ?? 10,
                        totalPages: response.totalPages ?? 1,
                        totalItems: response.totalItems ?? 0,
                        totalPaid: response.totalPaid ?? 0,
                        totalFree: response.totalFree ?? 0,
                        paidPercentage: response.paidPercentage ?? 0,
                        freePercentage: response.freePercentage ?? 0,
                        totalClicks: response.totalClicks ?? 0,
                        clickPercentage: response.clickPercentage ?? 0,
                    };

                    if (groupBy === "pack") {
                        return { data: items as PackPresetStats[], meta };
                    }

                    return { data: items as CreatorPresetStats[], meta };
                } catch (error) {
                    throw error;
                }
            },
        };

    static Instance = new PresetStatsService();
}